import { Settings } from 'lucide-react'
import { useMemo, useState } from 'react'

import FilterManagementDropdown from '../../brokers/needs_attention/FilterManagementDropdown'
import { filterByLabelAndValueCallback } from '../../brokers/needs_attention/utils'
import { type MultipleSelectedValuesFilter } from '../../brokers/types'
import ComboboxMultiSelectFilter, {
  type ComboboxFilterOption,
} from '../../reusable/table/ComboboxMultiSelectFilter'

const SourceFilter = (props: MultipleSelectedValuesFilter) => {
  const [query, setQuery] = useState('')

  // Hardcoding these options for now since it is only 2 options
  // but if we expand that later we can fetch this data instead.
  const sourceOptions: ComboboxFilterOption<string>[] = useMemo(() => [
    { label: 'Ideon', value: 'Ideon' },
    { label: 'Thatch', value: 'Thatch' },
  ], [])

  const filteredOptions = sourceOptions.filter(
    filterByLabelAndValueCallback(query)
  )

  return (
    <div>
      <ComboboxMultiSelectFilter
        {...props}
        options={[{ groupLabel: 'Source', options: filteredOptions }]}
        placeholder='Search sources to filter...'
        onValueChange={setQuery}
      >
        <FilterManagementDropdown
          {...props}
          options={sourceOptions}
          noSelectionText='Source'
          pluralIdentifier='sources'
        >
          <Settings size={20} />
        </FilterManagementDropdown>
      </ComboboxMultiSelectFilter>
    </div>
  )
}

export default SourceFilter
